export const QUEUE_PANEL_PROFILES = {
  tanning: {
    label: "Clínica de bronzeamento",
    preparationTitle: "Preparação para montagem do biquíni",
    preparationActionLabel: "Montar biquíni",
    preparationCompleteLabel: "Montagem pronta",
    preparationDescription: "Estamos preparando a montagem do seu biquíni com cuidado. Sua senha será chamada assim que estiver pronta.",
    preparationTip: "Respire fundo, hidrate-se e aproveite este momento de cuidado.",
    alertTitle: "Montagem precisa de atenção",
    alertBody: (clientName: string, minutes: number) => `${clientName} está em preparação há mais de ${minutes} minutos. Verifique a montagem do biquíni.`,
    preparationAlertMinutes: 25,
  },
  salon: {
    label: "Salão de beleza",
    preparationTitle: "Organizando seu atendimento",
    preparationActionLabel: "Preparar atendimento",
    preparationCompleteLabel: "Atendimento preparado",
    preparationDescription: "Nossa equipe está preparando o espaço e os detalhes para receber você. Sua senha será chamada assim que estiver tudo pronto.",
    preparationTip: "Aproveite este momento para relaxar. Em breve, seu atendimento começará.",
    alertTitle: "Atendimento precisa de atenção",
    alertBody: (clientName: string, minutes: number) => `${clientName} aguarda a preparação do atendimento há mais de ${minutes} minutos. Verifique a organização da estação.`,
    preparationAlertMinutes: 15,
  },
  advanced_aesthetics: {
    label: "Estética avançada",
    preparationTitle: "Preparando sua sessão",
    preparationActionLabel: "Preparar sessão",
    preparationCompleteLabel: "Sessão preparada",
    preparationDescription: "Nossa equipe está organizando os cuidados e a sala para a sua sessão. Você será chamada assim que estiver tudo pronto.",
    preparationTip: "Seu bem-estar é prioridade. Agradecemos por aguardar este momento de autocuidado.",
    alertTitle: "Sessão precisa de atenção",
    alertBody: (clientName: string, minutes: number) => `${clientName} aguarda a preparação da sessão há mais de ${minutes} minutos. Verifique a sala e os cuidados necessários.`,
    preparationAlertMinutes: 20,
  },
  barbershop: {
    label: "Barbearia",
    preparationTitle: "Preparando sua cadeira",
    preparationActionLabel: "Preparar cadeira",
    preparationCompleteLabel: "Cadeira preparada",
    preparationDescription: "Nossa equipe está organizando sua cadeira e os detalhes do atendimento. Você será chamado assim que estiver tudo pronto.",
    preparationTip: "Fique à vontade. Em breve, sua experiência na barbearia vai começar.",
    alertTitle: "Cadeira precisa de atenção",
    alertBody: (clientName: string, minutes: number) => `${clientName} aguarda a preparação da cadeira há mais de ${minutes} minutos. Verifique a organização do atendimento.`,
    preparationAlertMinutes: 10,
  },
  store: {
    label: "Loja de produtos",
    preparationTitle: "Vitrine de produtos",
    preparationActionLabel: "Abrir vitrine",
    preparationCompleteLabel: "Vitrine ativa",
    preparationDescription: "Conheça os produtos disponíveis na loja e escaneie o QR Code para comprar pelo celular.",
    preparationTip: "Selecione este perfil para transformar o painel de chamada em uma vitrine de vendas.",
    alertTitle: "Vitrine de produtos ativa",
    alertBody: () => "A vitrine de produtos está sendo exibida no painel.",
    preparationAlertMinutes: 0,
  },
} as const;

export type QueuePanelProfile = keyof typeof QUEUE_PANEL_PROFILES;

export function getQueuePanelProfile(profile?: string | null) {
  return QUEUE_PANEL_PROFILES[(profile ?? "tanning") as QueuePanelProfile] ?? QUEUE_PANEL_PROFILES.tanning;
}
